import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type ClassDetails } from '~entities/classes/modal/class';
import { invalidateSessionLinkedCounts } from '~entities/session/api/get-class-event-count-session-by-id';

import { baseAPI } from '~shared/api/base-api';

interface BulkDeleteClassesParams {
  classIds: Array<string>;
}

export const bulkDeleteClassesAPI = async (params: BulkDeleteClassesParams) => {
  const response = await baseAPI.delete<Array<ClassDetails>>(
    '/enrollments/batch/all',
    {
      data: params.classIds,
    },
  );
  return response.data;
};

export const useBulkDeleteClasses = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: BulkDeleteClassesParams) =>
      bulkDeleteClassesAPI(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['classes'] });
      void invalidateSessionLinkedCounts(queryClient);
    },
  });
};
